import { Tag } from '@cian/components';
import * as React from 'react';

import { FDealType } from '../../../../utils/category';
import { IRoomsInDealTag } from '../../../state/tags/definitions/rooms_in_deal';
import { TagNew } from '../TagNew';
import { tagThemeSmall } from '../tag_theme';

export interface IRoomsInDealTagItemProps {
  tag: IRoomsInDealTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const RoomsInDealTagItem = ({ tag, onDeleteClick, withNewTag }: IRoomsInDealTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Комнат {tag.dealType === FDealType.Sale ? `на продажу` : `в аренду`}: от {tag.value}
    </TagComponent>
  );
};
